import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analyticscomparism',
  templateUrl: './analyticscomparism.component.html',
  styleUrls: ['./analyticscomparism.component.css']
})
export class AnalyticscomparismComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
